import React, { useState, useEffect, useContext } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useNavigate } from 'react-router';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import { Row, Col } from 'reactstrap';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableFooter from '@mui/material/TableFooter';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Pagination from '@mui/material/Pagination';
import EditIcon from '@mui/icons-material/Edit';
import VReportsAttorneyData from '@services/VReportsAttorneyData';
import AppContext from '@contexts/AppContext';
import TableSortLabel from '@mui/material/TableSortLabel';
import ReactLoading from 'react-loading';
import FilteringFields from './FilteringFields';
import Moment from 'moment';
import { FormattedAmount } from '../../../components/Utils/FormattedAmount';
import { Link } from 'react-router-dom';
import fileDownload from 'js-file-download';
import { toast } from 'react-toastify';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  head: {
    backgroundColor: '#efefef',
    color: theme.palette.common.black,
  },
  body: {
    fontSize: '14px', // Set font size for the body cells only
  },
}));

const useStyles2 = {
  minWidth: 500,
};

export default function CustomPaginationActionsTable() {
  const appContext = useContext(AppContext);

  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(15);
  const [filters, setFilters] = useState(appContext.attorneyDataReportFilters);
  const [orderBy, setOrderBy] = useState('Attorney');
  const [orderDir, setOrderDir] = useState('ASC');
  const [rows, setRows] = useState([]);

  const navigate = useNavigate();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    if (!filters.dateRange || filters.dateRange == '') {
      let tempFilters = {
        ...filters,
        dateRange: 'This month',
      };
      setFilters(tempFilters);
      appContext.attorneyDataReportFilters = tempFilters;
      localStorage.setItem('attorneyDataReportFilters', JSON.stringify(tempFilters));
      loadData(tempFilters);
    } else {
      loadData(filters);
    }
  }, [page, orderBy, orderDir, rowsPerPage]);

  const loadData = (filters) => {
    let reqFilters = filters;
    if (reqFilters && reqFilters.attorney) {
      reqFilters = { ...reqFilters, AttorneyPublicId: reqFilters.attorney.publicId };
    }
    if (reqFilters && reqFilters.lawFirm) {
      reqFilters = { ...reqFilters, LawFirmPublicId: reqFilters.lawFirm.publicId };
    }

    delete reqFilters.lawFirm;
    delete reqFilters.attorney;
    setIsLoading(true);
    VReportsAttorneyData.search(reqFilters, orderBy, orderDir, page, null, rowsPerPage)
      .then((response) => {
        setRows(response.data.data);
        setPages(response.data.pages.slice(-1)[0]);
        setIsLoading(false);
      })
      .catch((err) => {})
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getAll = () => {
    let tempFilters = {
      dateRange: 'This month',
    };
    setFilters(tempFilters);
    appContext.attorneyDataReportFilters = tempFilters;
    localStorage.setItem('attorneyDataReportFilters', JSON.stringify(tempFilters));
    update(tempFilters);
  };

  const update = (filters) => {
    let reqFilters = filters;
    if (reqFilters && reqFilters.attorney) {
      reqFilters = { ...reqFilters, AttorneyPublicId: reqFilters.attorney.publicId };
    }
    if (reqFilters && reqFilters.lawFirm) {
      reqFilters = { ...reqFilters, LawFirmPublicId: reqFilters.lawFirm.publicId };
    }

    delete reqFilters.lawFirm;
    delete reqFilters.attorney;

    setIsLoading(true);
    VReportsAttorneyData.search(reqFilters, orderBy, orderDir, page, null, rowsPerPage)
      .then((response) => {
        setRows(response.data.data);
        setPages(response.data.pages.slice(-1)[0]);
        setIsLoading(false);
      })
      .catch((err) => {})
      .finally(() => {
        setIsLoading(false);
      });
  };

  const exportTo = (filters) => {
    let reqFilters = filters;
    if (reqFilters && reqFilters.attorney) {
      reqFilters = { ...reqFilters, AttorneyPublicId: reqFilters.attorney.publicId };
    }
    if (reqFilters && reqFilters.lawFirm) {
      reqFilters = { ...reqFilters, LawFirmPublicId: reqFilters.lawFirm.publicId };
    }

    delete reqFilters.lawFirm;
    delete reqFilters.attorney;

    setIsLoading(true);
    VReportsAttorneyData.export(reqFilters, orderBy, orderDir, page, null, rowsPerPage)
      .then((response) => {
        const contentDisposition = response.headers['content-disposition'];
        let fileName = 'Data-Export.xlsx';
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
          if (fileNameMatch != null && fileNameMatch.length === 2) fileName = fileNameMatch[1];
        }
        fileDownload(response.data, fileName);
        setIsLoading(false);
      })
      .catch((err) => {})
      .finally(() => {
        setIsLoading(false);
      });
  };

  const searchWithFilters = (filters) => {
    var newFilters = { ...filters };
    setFilters(newFilters);
    appContext.attorneyDataReportFilters = newFilters;
    localStorage.setItem('attorneyDataReportFilters', JSON.stringify(newFilters));
    if (page === 1) update(newFilters);
    else setPage(1);
  };

  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [rowIndex, setRowIndex] = useState(undefined);
  const [givenRows, setGivenRows] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(undefined);

  const [activeFieldForSorting, setActiveFieldForSorting] = useState();

  const arrange = (field) => {
    if (orderBy === field) {
      if (orderDir === 'ASC') {
        setOrderDir('DESC');
      } else {
        setOrderDir('ASC');
      }
    } else {
      setOrderBy(field);
      setOrderDir('ASC');
    }

    setPage(1);
  };

  const handlePageSizeChange = (event) => {
    setRowsPerPage(event.target.value);
  };

  const exportAttorneyDataReport = () => {
    exportTo(filters);
  };

  return (
    <>
      <div className="d-flex mt-5 mb-10">
        <div className="mr-auto">
          <h1>Attorney Data Report</h1>
        </div>
        <Link
          onClick={exportAttorneyDataReport}
          className="btn btn-primary"
          style={{
            backgroundColor: 'var(--green)',
            borderColor: 'var(--green)',
            minWidth: '100px',
          }}
        >
          Export
        </Link>
      </div>
      <FilteringFields searchWithFilters={searchWithFilters} getAll={getAll}></FilteringFields>
      <Col md="10" className="float-right">
        <TableContainer component={Paper}>
          <Table className={useStyles2} aria-label="custom pagination table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Id</StyledTableCell>

                <StyledTableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                  Attorney
                </StyledTableCell>

                <StyledTableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                  {' '}
                  Law Firm
                </StyledTableCell>

                <StyledTableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                  Address
                </StyledTableCell>

                <StyledTableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                  State
                </StyledTableCell>

                <StyledTableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                  Email Address
                </StyledTableCell>

                <StyledTableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                  Phone No
                </StyledTableCell>

                <StyledTableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                  Website
                </StyledTableCell>

                <StyledTableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                  # of Applications
                </StyledTableCell>

                <StyledTableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                  # of Applications - Unable to Approve
                </StyledTableCell>

                <StyledTableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                  # of Applications - Active Advance Receivable
                </StyledTableCell>

                <StyledTableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                  # of Applications - Client Denied Advance
                </StyledTableCell>

                <StyledTableCell className="adr-total-payouts">Total Payouts</StyledTableCell>

                <StyledTableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                  APR Ind
                </StyledTableCell>

                <StyledTableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                  APR Agg
                </StyledTableCell>

                <StyledTableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                  Date of Last File
                </StyledTableCell>

                <StyledTableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                  Account Manager Name
                </StyledTableCell>
              </TableRow>
            </TableHead>
            {isLoading === false && (
              <TableBody>
                {rows &&
                  rows.map((row, index) => (
                    <TableRow key={row.name}>
                      <TableCell component="th" scope="row">
                        {row.id}
                      </TableCell>
                      <TableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                        {row.attorney}
                      </TableCell>
                      <TableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                        {row.lawFirm}
                      </TableCell>
                      <TableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                        {row.streetAddress}
                      </TableCell>
                      <TableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                        {row.stateCode}
                      </TableCell>
                      <TableCell
                        style={{ minWidth: '110px', maxWidth: '110px', wordBreak: 'break-word' }}
                      >
                        {row.emailAddress}
                      </TableCell>
                      <TableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                        {row.workingPhoneNo}
                      </TableCell>
                      <TableCell
                        style={{ minWidth: '110px', maxWidth: '110px', wordBreak: 'break-word' }}
                      >
                        {row.website}
                      </TableCell>
                      <TableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                        {row.totalApplications}
                      </TableCell>
                      <TableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                        {row.totalAppsUnabletoApprove}
                      </TableCell>
                      <TableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                        {row.totalAppsActiveAdvanceReceivable}
                      </TableCell>
                      <TableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                        {row.totalAppsClientDeniedAdvance}
                      </TableCell>
                      <TableCell className="adr-total-payouts">
                        {row?.totalPayouts
                          ? FormattedAmount.format(parseFloat(row.totalPayouts).toFixed(2))
                          : '-'}
                      </TableCell>
                      <TableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                        {row.aprInd}
                      </TableCell>
                      <TableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                        {row.aprAgg}
                      </TableCell>
                      <TableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                        {row?.dateofLastFile &&
                          Moment(row?.dateofLastFile?.split('T')[0]).format('MM-DD-YYYY')}
                      </TableCell>
                      <TableCell style={{ minWidth: '110px', maxWidth: '110px' }}>
                        {row.accountManagerName}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            )}
            {isLoading && (
              <TableBody>
                <TableRow>
                  <td></td>
                  <td>
                    <ReactLoading type="bars" color="#7E8299" />
                  </td>
                  <td></td>
                </TableRow>
              </TableBody>
            )}

            <TableFooter></TableFooter>
          </Table>
        </TableContainer>
        <div className="float-left mt-5">
          <select onChange={handlePageSizeChange} className="form-control" defaultValue={15}>
            {[5, 10, 15, 25, 100].map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </div>
        <div className="float-right mt-5">
          <Pagination
            count={pages}
            page={page}
            siblingCount={1}
            boundaryCount={1}
            variant="outlined"
            onChange={handleChangePage}
          />
        </div>
      </Col>
    </>
  );
}
